import { openBlock as r, createElementBlock as u, normalizeClass as o, unref as n, withModifiers as ye, toDisplayString as C, createElementVNode as _, createCommentVNode as k, mergeProps as b, createTextVNode as P, renderSlot as h, computed as w, createVNode as v, Fragment as q, renderList as O, createBlock as x, withCtx as M, useAttrs as re, toHandlers as ge, ref as $, normalizeProps as T, guardReactiveProps as j, useSlots as ve, normalizeStyle as J, nextTick as K, resolveDynamicComponent as X, watch as oe, onBeforeUnmount as ie, onMounted as de } from "vue";
import { CdrBreadcrumb as ke, IconCaretRight as ue, IconCaretUp as we, IconCaretDown as $e, IconXSm as xe, CdrSelect as Ce, IconCaretLeft as Se, CdrContainer as Me } from "@rei/cedar";
import V from "raf";
import "core-js/modules/es.array.push.js";
const Le = "_main_iyr5v_2", qe = {
  main: Le
}, Ie = ["href", "onClick"], Pe = {
  __name: "SkipToLink",
  props: {
    link: {
      type: String,
      required: !0
    },
    text: {
      type: String,
      default: null
    }
  },
  setup(t) {
    const e = t;
    function l() {
      const a = document.getElementById(e.link);
      if (!a)
        return;
      const s = a.tabIndex;
      a.tabIndex = -1, a.focus();
      const c = () => {
        a.tabIndex = s, a.removeEventListener("blur", c);
      };
      a.addEventListener("blur", c);
    }
    return (a, s) => (r(), u("a", {
      class: o(n(qe).main),
      href: `#${e.link}`,
      onClick: ye(l, ["prevent"])
    }, " Skip to " + C(e.text || e.link), 11, Ie));
  }
}, Oe = "_count_17tiq_25", Be = "_heading_17tiq_37", Z = {
  count: Oe,
  heading: Be
}, Ae = {
  __name: "Heading",
  props: {
    title: {
      type: String,
      required: !0
    },
    count: {
      type: Number,
      required: !0
    }
  },
  setup(t) {
    const e = (l) => `${l}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return (l, a) => (r(), u("div", null, [_("h1", {
      class: o(n(Z).heading),
      "aria-live": "polite"
    }, C(t.title), 3), t.count ? (r(), u("small", {
      key: 0,
      class: o(n(Z).count)
    }, C(` (${e(t.count)} result${t.count > 1 ? "s" : ""})`), 3)) : k("", !0)]));
  }
}, He = {
  __name: "Breadcrumb",
  props: {
    link: {
      type: Object,
      required: !0
    },
    label: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    return (e, l) => (r(), u("li", null, [_("a", b(t.link, {
      class: e.$attrs.class
    }), [P(C(t.label) + " ", 1), h(e.$slots, "default")], 16)]));
  }
}, Te = "_breadcrumb_l3vxb_2", Ee = "_breadcrumbs_l3vxb_37", Fe = "_arrow_l3vxb_55", Ne = "_breadcrumbContainer_l3vxb_62", D = {
  breadcrumb: Te,
  breadcrumbs: Ee,
  arrow: Fe,
  breadcrumbContainer: Ne
}, Re = {
  inheritAttrs: !1
}, je = Object.assign(Re, {
  __name: "Breadcrumbs",
  props: {
    items: {
      type: Array,
      required: !0,
      validator: (t) => {
        for (let e = 0; e < t.length; e += 1)
          if (typeof t[e].key != "string")
            return !1;
        return !0;
      }
    },
    useCdrBreadcrumbs: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, l = w(() => e.items.map((s) => {
      var c, d;
      return {
        item: {
          name: s.label,
          url: ((c = s == null ? void 0 : s.link) == null ? void 0 : c.href) || s.key,
          id: s.key,
          navigate: ((d = s == null ? void 0 : s.link) == null ? void 0 : d.onClick) || (() => {
          })
        }
      };
    })), a = (s, c) => {
      var d, i;
      (i = (d = s == null ? void 0 : s.item) == null ? void 0 : d.navigate) == null || i.call(d, c);
    };
    return (s, c) => t.useCdrBreadcrumbs ? (r(), u("div", {
      key: 0,
      class: o(n(D).breadcrumbContainer)
    }, [v(n(ke), {
      items: l.value,
      onNavigate: a
    }, null, 8, ["items"])], 2)) : (r(), u("ol", {
      key: 1,
      class: o([n(D).breadcrumbs, s.$attrs.class])
    }, [(r(!0), u(q, null, O(t.items, ({
      key: d,
      ...i
    }, p) => (r(), x(He, b({
      key: d,
      class: n(D).breadcrumb
    }, i), {
      default: M(() => [p + 1 < t.items.length ? (r(), x(n(ue), {
        key: 0,
        class: o(n(D).arrow),
        "aria-hidden": "true"
      }, null, 8, ["class"])) : k("", !0)]),
      _: 2
    }, 1040, ["class"]))), 128))], 2));
  }
}), De = "_filter_19yln_3", We = "_radio_19yln_76", ze = "_disabled_19yln_92", Ue = "_active_19yln_109", W = {
  filter: De,
  radio: We,
  disabled: ze,
  active: Ue
}, Ke = ["tab-index"], Ve = ["innerHTML"], Ge = ["tab-index"], Xe = ["innerHTML"], Ye = {
  inheritAttrs: !1
}, ce = Object.assign(Ye, {
  __name: "FilterLink",
  props: {
    link: {
      type: Object,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    expanded: {
      type: Boolean,
      required: !0
    },
    selected: {
      type: Boolean,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    radio: {
      type: Boolean,
      default: !1
    },
    activeClass: {
      type: String,
      default: W.active
    },
    highlight: {
      type: String,
      default: ""
    },
    filterClass: {
      type: String,
      default: W.filter
    }
  },
  setup(t) {
    const e = t, l = re(), a = w(() => {
      const c = e.highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return e.label.replace(new RegExp(c, "i"), (d) => d && `<strong>${d}</strong>`);
    }), s = w(() => [l.class, e.filterClass, e.selected && e.activeClass, e.radio && W.radio, e.disabled && W.disabled]);
    return (c, d) => e.disabled || e.radio && e.selected ? (r(), u("button", {
      key: 0,
      type: "button",
      disabled: "disabled",
      class: o(s.value),
      "tab-index": e.expanded ? void 0 : -1
    }, [h(c.$slots, "pre"), h(c.$slots, "default", {}, () => [_("span", {
      innerHTML: a.value
    }, null, 8, Ve)]), h(c.$slots, "post")], 10, Ke)) : (r(), u("a", b({
      key: 1,
      class: s.value,
      "tab-index": e.expanded ? void 0 : -1
    }, e.link.attrs, ge(e.link.on, !0)), [h(c.$slots, "pre"), h(c.$slots, "default", {}, () => [_("span", {
      innerHTML: a.value
    }, null, 8, Xe)]), h(c.$slots, "post")], 16, Ge));
  }
}), Je = "150", Qe = "_showMore_wld1v_3", Ze = "_animated_wld1v_41", et = "_filters_wld1v_45", tt = "_mobileShown_wld1v_68", N = {
  duration: Je,
  showMore: Qe,
  animated: Ze,
  filters: et,
  mobileShown: tt
}, nt = {
  __name: "FilterLinkListContent",
  props: {
    hideMore: {
      type: Boolean,
      default: !0
    },
    items: {
      type: Array,
      default: null
    },
    maxLength: {
      type: Number,
      default: 10
    },
    showMoreStartIx: {
      type: Number,
      default: 6
    }
  },
  setup(t) {
    const e = t, l = $(null), a = $(null), s = (d) => {
      if (d === e.items.length - 1)
        return l;
      if (d === e.showMoreStartIx)
        return a;
    }, c = (d) => e.items.length >= e.maxLength && d > e.showMoreStartIx && e.hideMore;
    return (d, i) => (r(!0), u(q, null, O(t.items, (p, f) => (r(), u("li", {
      key: p.key,
      ref_for: !0,
      ref: s(f),
      class: o({
        [n(N).mobileShown]: c(f)
      })
    }, [v(ce, T(j(p.props)), null, 16)], 2))), 128));
  }
}, pe = (t) => t.offsetParent, ee = {
  transition: "transitionend",
  WebkitTransition: "webkitTransitionEnd",
  MozTransition: "transitionend",
  OTransition: "oTransitionEnd otransitionend"
};
let Y;
if (typeof window < "u") {
  const {
    style: t
  } = document.createElement("div"), e = Object.keys(ee);
  for (let l = 0, a = e[l]; l < e.length; l += 1, a = e[l])
    if (a in t) {
      Y = ee[a];
      break;
    }
}
const Q = (t, e, l) => {
  t.addEventListener(Y, e);
  let a = !1;
  const s = () => {
    a || (t.removeEventListener(Y, e), a = !0);
  }, c = setTimeout(e, l + 16);
  return () => {
    s(), clearTimeout(c);
  };
}, lt = "768px", st = "_bold_1kivl_6", at = "_srOnly_1kivl_10", rt = "_hidden_1kivl_22", ot = "_mobileShown_1kivl_27", it = "_mobileHidden_1kivl_32", S = {
  mdMin: lt,
  bold: st,
  srOnly: at,
  hidden: rt,
  mobileShown: ot,
  mobileHidden: it
}, dt = "150", ut = "_showMore_wld1v_3", ct = "_animated_wld1v_41", pt = "_filters_wld1v_45", ft = "_mobileShown_wld1v_68", mt = {
  duration: dt,
  showMore: ut,
  animated: ct,
  filters: pt,
  mobileShown: ft
}, fe = (t, e) => {
  const l = t.__vccOpts || t;
  for (const [a, s] of e)
    l[a] = s;
  return l;
}, _t = ["tab-index"], bt = {
  __name: "FilterLinkList",
  props: {
    maxLength: {
      type: Number,
      default: 10
    },
    showMoreStartIx: {
      type: Number,
      default: 6
    },
    expanded: {
      type: Boolean,
      required: !0
    },
    showMoreText: {
      type: String,
      default: null
    },
    showLessText: {
      type: String,
      default: null
    }
  },
  setup(t) {
    const e = t, l = ve(), a = parseInt(N.duration, 10), s = $(null), c = $(null), d = $(!1), i = $(null), p = $(!1), f = $(null), y = $(null);
    async function g() {
      i.value && i.value();
      const {
        lastLi: E,
        li7: I
      } = c.value;
      d.value = !d.value, p.value = !0, f.value = `${s.value.offsetHeight}px`, y.value = "hidden", await K(), pe(s.value);
      const me = V(() => {
        const {
          offsetTop: _e,
          offsetHeight: be
        } = !d.value && I.value ? I.value : E.value;
        i.value = Q(s.value, async () => {
          i.value(), p.value = !1, i.value = null, await K(), f.value = "", y.value = "";
        }, a);
        const he = `${_e + be}px`;
        f.value = he;
      });
      i.value = () => V.cancel(me);
    }
    function L(E) {
      return E.map((I) => Array.isArray(I.children) ? I.children : I.type.toString() === "Symbol(Comment)" ? [] : [I]).flat();
    }
    const G = w(() => L(l.default()).length > e.maxLength);
    return (E, I) => (r(), u("div", null, [_("ul", {
      ref_key: "ul",
      ref: s,
      style: J({
        height: f.value,
        overflow: y.value
      }),
      class: o([n(N).filters, n(N).animated])
    }, [v(nt, {
      ref_key: "content",
      ref: c,
      "hide-more": !d.value && !p.value,
      items: L(n(l).default()),
      "max-length": t.maxLength,
      "show-more-start-ix": t.showMoreStartIx
    }, null, 8, ["hide-more", "items", "max-length", "show-more-start-ix"])], 6), G.value ? (r(), u("button", {
      key: 0,
      type: "button",
      class: o([n(S).mobileHidden, n(N).showMore]),
      "tab-index": e.expanded ? 0 : -1,
      onClick: g
    }, C(d.value ? t.showLessText || "Show less" : t.showMoreText || "Show all"), 11, _t)) : k("", !0)]));
  }
}, ht = {
  $style: mt
}, yt = /* @__PURE__ */ fe(bt, [["__cssModules", ht]]), gt = "_main_otylg_3", vt = "_collapsable_otylg_28", kt = "_title_otylg_35", wt = "_iconWrapper_otylg_40", $t = "_expand_otylg_55", xt = "_close_otylg_58", z = {
  main: gt,
  collapsable: vt,
  title: kt,
  iconWrapper: wt,
  expand: $t,
  close: xt
}, Ct = {
  __name: "AccordionButton",
  props: {
    expanded: {
      type: Boolean,
      default: !0
    },
    collapsable: {
      type: Boolean,
      required: !0
    },
    onClick: {
      type: Function,
      default: () => {
      }
    },
    tag: {
      type: String,
      default: "button"
    },
    reverseIcons: {
      type: Boolean,
      required: !0
    }
  },
  setup(t) {
    const e = t, l = w(() => e.reverseIcons ? !e.expanded : e.expanded), a = w(() => e.collapsable ? re() : {});
    return (s, c) => (r(), x(X(e.tag), b({
      class: [n(z).main, {
        [n(z).collapsable]: e.collapsable
      }]
    }, a.value, {
      onClick: t.onClick
    }), {
      default: M(() => [_("div", {
        class: o(n(z).title)
      }, [h(s.$slots, "default")], 2), e.collapsable ? (r(), u("div", {
        key: 0,
        class: o(n(z).iconWrapper)
      }, [l.value ? (r(), x(n(we), {
        key: 0,
        "aria-hidden": "true"
      })) : (r(), x(n($e), {
        key: 1,
        "aria-hidden": "true"
      }))], 2)) : k("", !0)]),
      _: 3
    }, 16, ["class", "onClick"]));
  }
}, St = "1.5rem", Mt = "150", Lt = "_filterMenu_5ak9u_2", qt = "_wrapper_5ak9u_20", It = "_animated_5ak9u_28", Pt = "_expanded_5ak9u_32", Ot = "_hidden_5ak9u_37", B = {
  paddingBottom: St,
  duration: Mt,
  filterMenu: Lt,
  wrapper: qt,
  animated: It,
  expanded: Pt,
  hidden: Ot
}, Bt = ["id", "aria-hidden"], At = {
  __name: "Accordion",
  props: {
    id: {
      type: String,
      required: !0
    },
    expanded: {
      type: Boolean,
      required: !0
    },
    collapsable: {
      type: Boolean,
      required: !0
    },
    toggle: {
      type: Function,
      required: !0
    },
    reverseIcons: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, l = parseInt(B.duration, 10), a = (g) => {
      const {
        documentElement: L
      } = document;
      return L ? Math.floor(parseFloat(g) * parseFloat(getComputedStyle(L).fontSize)) : 0;
    }, s = $(null), c = $(null), d = $(null), i = $(null), p = $(null), f = $(e.expanded ? "visible" : void 0);
    function y() {
      i.value = null, p.value = null, f.value = e.expanded ? "visible" : void 0, d.value && (d.value(), d.value = null);
    }
    return oe(() => e.expanded, async () => {
      const {
        collapsable: g,
        expanded: L
      } = e;
      if (d.value && (d.value(), d.value = null), !g)
        return;
      if (!c.value.offsetParent) {
        y();
        return;
      }
      L ? i.value = "0" : (f.value = "", i.value = `${c.value.offsetHeight}px`), p.value = "0", await K(), pe(c.value);
      const G = V(() => {
        d.value = Q(c.value, y, l), L ? i.value = `${c.value.scrollHeight + a(B.paddingBottom)}px` : i.value = "0";
      });
      d.value = () => V.cancel(G);
    }), ie(() => {
      d.value && d.value();
    }), (g, L) => (r(), u("div", {
      class: o(n(B).filterMenu)
    }, [v(Ct, b({
      id: `${t.id}-header`,
      ref_key: "heading",
      ref: s
    }, {
      expanded: e.expanded,
      reverseIcons: e.reverseIcons,
      collapsable: e.collapsable,
      tag: e.collapsable ? "button" : "div",
      onClick: e.collapsable ? e.toggle : null
    }, {
      "aria-controls": e.collapsable ? e.id : void 0,
      "aria-expanded": e.collapsable ? String(e.expanded) : void 0
    }), {
      default: M(() => [h(g.$slots, "title")]),
      _: 3
    }, 16, ["id", "aria-controls", "aria-expanded"]), _("div", {
      id: t.id,
      ref_key: "wrapper",
      ref: c,
      "aria-hidden": !e.collapsable || e.expanded ? void 0 : "true",
      class: o([n(B).wrapper, n(B).animated, {
        [!e.collapsable || e.expanded ? n(B).expanded : n(B).hidden]: !0
      }]),
      style: J({
        height: i.value,
        paddingBottom: p.value,
        overflow: f.value
      })
    }, [h(g.$slots, "default")], 14, Bt)], 2));
  }
}, Ht = {
  inheritAttrs: !1
}, Tt = Object.assign(Ht, {
  __name: "FilterMenu",
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: [String, Object],
      required: !0
    },
    items: {
      type: Array,
      required: !0,
      validator: (t) => {
        for (let e = 0; e < t.length; e += 1)
          if (t[e].key && typeof t[e].key != "string")
            return !1;
        return !0;
      }
    },
    collapsable: {
      type: Boolean,
      default: !1
    },
    expanded: {
      type: Boolean,
      required: !0
    },
    toggle: {
      type: Function,
      required: !0
    }
  },
  setup(t) {
    return (e, l) => (r(), x(At, {
      id: t.id,
      expanded: t.expanded,
      collapsable: t.collapsable,
      toggle: t.toggle
    }, {
      title: M(() => [_("span", {
        class: o(n(S).srOnly)
      }, "Filter by ", 2), h(e.$slots, "title", {}, () => [P(C(t.title), 1)])]),
      default: M(() => [h(e.$slots, "items", {
        filterItems: t.items
      }, () => [v(yt, {
        expanded: t.expanded
      }, {
        default: M(() => [(r(!0), u(q, null, O(t.items, ({
          key: a,
          ...s
        }) => (r(), x(ce, b({
          key: a
        }, s, {
          expanded: t.expanded
        }), null, 16, ["expanded"]))), 128))]),
        _: 1
      }, 8, ["expanded"])])]),
      _: 3
    }, 8, ["id", "expanded", "collapsable", "toggle"]));
  }
}), Et = "_list_96jy0_2", Ft = "_listItem_96jy0_14", te = {
  list: Et,
  listItem: Ft
}, Nt = {
  __name: "FilterRail",
  props: {
    items: {
      type: Array,
      required: !0,
      validator: (t) => {
        for (let e = 0; e < t.length; e += 1)
          if (typeof t[e].key != "string")
            return !1;
        return !0;
      }
    }
  },
  setup(t) {
    return (e, l) => (r(), u("ul", {
      class: o(n(te).list)
    }, [(r(!0), u(q, null, O(t.items, (a) => (r(), u("li", {
      key: a.key,
      class: o(n(te).listItem)
    }, [h(e.$slots, "default", T(j(a)), () => [v(Tt, T(j(a)), null, 16)])], 2))), 128))], 2));
  }
}, Rt = {}, jt = {
  __name: "LoadingDots",
  setup(t) {
    return (e, l) => (r(), u("div", {
      class: o(n(Rt).dots)
    }, " Loading ... ", 2));
  }
}, Dt = "_clearAll_12fxg_2", Wt = "_appliedRefinement_12fxg_37", zt = "_label_12fxg_115", Ut = "_close_12fxg_121", U = {
  clearAll: Dt,
  appliedRefinement: Wt,
  "cdr-button--has-icon-left": "_cdr-button--has-icon-left_12fxg_99",
  "cdr-button--has-icon-right": "_cdr-button--has-icon-right_12fxg_102",
  label: zt,
  close: Ut
}, ne = {
  __name: "AppliedRefinements",
  props: {
    items: {
      type: Array,
      required: !0,
      validator: (t) => {
        for (let e = 0; e < t.length; e += 1)
          if (typeof t[e].key != "string")
            return !1;
        return !0;
      }
    },
    clearAll: {
      type: Object,
      default: null
    }
  },
  setup(t) {
    return (e, l) => (r(), u("div", {
      class: o(e.$attrs.class)
    }, [(r(!0), u(q, null, O(t.items, (a) => (r(), u("a", b(a.link, {
      key: a.key,
      class: n(U).appliedRefinement
    }), [_("span", {
      class: o(n(S).srOnly)
    }, C(`Remove ${a.value} filter:`), 3), _("span", {
      class: o(n(U).label)
    }, C(a.label), 3), v(n(xe), {
      class: o(n(U).close),
      "aria-hidden": "true"
    }, null, 8, ["class"])], 16))), 128)), t.clearAll && t.items.length > 1 ? (r(), u("a", b({
      key: 0
    }, t.clearAll.link, {
      class: n(U).clearAll
    }), C(t.clearAll.label), 17)) : k("", !0)], 2));
  }
}, Kt = "_wrapper_199tu_25", Vt = "_select_199tu_37", le = {
  wrapper: Kt,
  select: Vt
}, Gt = ["data-label"], Xt = {
  __name: "Sorter",
  props: {
    options: {
      type: Array,
      required: !0
    },
    handleChange: {
      type: Function,
      required: !0
    },
    value: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    const e = t, l = $(null), a = $(null);
    function s(i) {
      e.handleChange(i);
    }
    const c = w(() => {
      const {
        options: i,
        value: p
      } = e;
      for (let f = 0; f < i.length; f += 1) {
        const y = i[f];
        if (p === y.value)
          return y.label;
      }
      return "";
    }), d = w(() => e.options.map((i) => ({
      ...i,
      text: i.label
    })));
    return oe(() => e.value, async () => {
      await K();
      const {
        style: {
          color: i
        },
        style: p
      } = l.value;
      p.color = "#222", p.color = i;
    }), de(() => {
      a.value = e.value;
    }), (i, p) => (r(), u("div", {
      ref_key: "wrapper",
      ref: l,
      class: o(n(le).wrapper),
      "data-label": c.value.value
    }, [v(n(Ce), {
      ref_key: "select",
      ref: a,
      label: "Sort by",
      "aria-label": "Sort By",
      "hide-label": "",
      class: o(n(le).select),
      "model-value": e.value,
      options: d.value.value,
      onChange: s
    }, null, 8, ["class", "model-value", "options"])], 10, Gt));
  }
}, Yt = "_container_1eq57_3", Jt = "_pageLink_1eq57_10", Qt = "_arrow_1eq57_38", Zt = "_ellipsis_1eq57_45", en = "_active_1eq57_52", A = {
  container: Yt,
  pageLink: Jt,
  arrow: Qt,
  ellipsis: Zt,
  active: en
}, tn = {
  inheritAttrs: !1
}, F = Object.assign(tn, {
  __name: "PaginatorPage",
  props: {
    number: {
      type: Number,
      default: 0
    },
    position: {
      type: String,
      default: null
    },
    currentPage: {
      type: Number,
      default: 1
    },
    getLink: {
      type: Function,
      required: !0
    }
  },
  setup(t) {
    const e = t, l = w(() => {
      let s = "Go to page ";
      return e.position === "previous" ? s = "Go to previous page" : e.position === "next" && (s = "Go to next page"), s;
    }), a = w(() => {
      const s = {
        component: "span",
        ariaHidden: void 0,
        text: `${e.number}`
      };
      return e.position === "previous" ? (s.component = Se, s.ariaHidden = !0, s.text = void 0) : e.position === "next" && (s.component = ue, s.ariaHidden = !0, s.text = void 0), s;
    });
    return (s, c) => e.currentPage === e.number ? (r(), u("span", {
      key: 0,
      class: o([n(A).pageLink, n(A).active])
    }, [_("span", {
      class: o(n(S).srOnly)
    }, "You are currently on page ", 2), (r(), x(X(a.value.component), {
      "aria-hidden": a.value.ariaHidden,
      class: o(n(A).arrow)
    }, {
      default: M(() => [P(C(a.value.text), 1)]),
      _: 1
    }, 8, ["aria-hidden", "class"]))], 2)) : (r(), u("a", b({
      key: 1,
      class: [n(A).pageLink, {
        [n(A).active]: e.currentPage === e.number
      }]
    }, t.getLink(e.number)), [_("span", {
      class: o(n(S).srOnly)
    }, C(l.value), 3), (r(), x(X(a.value.component), {
      "aria-hidden": a.value.ariaHidden,
      class: o(n(A).arrow),
      alt: l.value
    }, {
      default: M(() => [P(C(a.value.text), 1)]),
      _: 1
    }, 8, ["aria-hidden", "class", "alt"]))], 16));
  }
}), nn = {
  key: 1,
  "aria-hidden": "true"
}, ln = {
  key: 2,
  "aria-hidden": "true"
}, sn = {
  __name: "Paginator",
  props: {
    totalPages: {
      type: Number,
      default: 1
    },
    currentPage: {
      type: Number,
      default: 1
    },
    getLink: {
      type: Function,
      required: !0
    }
  },
  setup(t) {
    const e = t, l = w(() => e.currentPage <= e.totalPages), a = w(() => e.currentPage > 4 && e.totalPages > 7), s = w(() => e.totalPages - e.currentPage > 3 && e.totalPages > 7), c = w(() => e.currentPage - 1), d = w(() => e.currentPage + 1), i = w(() => {
      const {
        totalPages: p,
        currentPage: f
      } = e, y = [];
      if (p <= 7)
        for (let g = 2; g < p; g += 1)
          y.push(g);
      else if (f <= 4)
        for (let g = 2; g <= 5; g += 1)
          y.push(g);
      else if (p - f <= 3)
        for (let g = p - 4; g < p; g += 1)
          y.push(g);
      else
        y.push(f - 1, f, f + 1);
      return y;
    });
    return (p, f) => e.totalPages > 1 ? (r(), u("nav", {
      key: 0,
      class: o(n(A).container)
    }, [e.currentPage > 1 ? (r(), x(F, b({
      key: 0
    }, p.$props, {
      number: c.value,
      position: "previous"
    }), null, 16, ["number"])) : k("", !0), v(F, b(p.$props, {
      number: 1
    }), null, 16), a.value ? (r(), u("span", nn, "…")) : k("", !0), (r(!0), u(q, null, O(i.value, (y) => (r(), x(F, b({
      key: `${e.position || ""}${y}`
    }, p.$props, {
      number: y
    }), null, 16, ["number"]))), 128)), s.value ? (r(), u("span", ln, "…")) : k("", !0), l.value ? (r(), x(F, b({
      key: 3
    }, p.$props, {
      number: e.totalPages
    }), null, 16, ["number"])) : k("", !0), e.currentPage < e.totalPages ? (r(), x(F, b({
      key: 4
    }, p.$props, {
      number: d.value,
      position: "next"
    }), null, 16, ["number"])) : k("", !0)], 2)) : k("", !0);
  }
}, an = "_link_1l9nx_3", rn = "_container_1l9nx_37", on = "_label_1l9nx_45", dn = "_item_1l9nx_50", H = {
  link: an,
  container: rn,
  label: on,
  item: dn
}, un = {
  __name: "ItemsPerPageEntry",
  props: {
    link: {
      type: Object,
      default: null
    },
    selected: {
      type: Boolean,
      required: !0
    },
    count: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    const e = t;
    return (l, a) => e.selected ? (r(), u("span", {
      key: 0,
      class: o(n(H).selected)
    }, [_("span", {
      class: o(n(S).srOnly)
    }, "Showing", 2), P(" " + C(t.count) + " ", 1), _("span", {
      class: o(n(S).srOnly)
    }, "results per page", 2)], 2)) : (r(), u("a", b({
      key: 1
    }, t.link, {
      class: n(H).link
    }), [_("span", {
      class: o(n(S).srOnly)
    }, "Show", 2), P(" " + C(t.count) + " ", 1), _("span", {
      class: o(n(S).srOnly)
    }, "results per page", 2)], 16));
  }
}, cn = {
  __name: "ItemsPerPage",
  props: {
    items: {
      type: Array,
      required: !0,
      validator(t) {
        if (!Array.isArray(t))
          return !1;
        for (let e = 0; e < t.length; e += 1) {
          const l = t[e];
          if (l.selected === !!l.link || typeof l.key != "string")
            return !1;
        }
        return !0;
      }
    }
  },
  setup(t) {
    const e = t;
    return (l, a) => e.items.length > 0 ? (r(), u("div", {
      key: 0,
      class: o(n(H).container)
    }, [_("span", {
      "aria-hidden": "true",
      class: o(n(H).label)
    }, "View:", 2), _("ul", {
      class: o(n(H).container)
    }, [(r(!0), u(q, null, O(e.items, ({
      key: s,
      ...c
    }) => (r(), u("li", {
      key: s,
      class: o(n(H).item)
    }, [v(un, T(j(c)), null, 16)], 2))), 128))], 2)], 2)) : k("", !0);
  }
}, pn = "_tabs_1rvfm_25", fn = "_tab_1rvfm_25", mn = "_active_1rvfm_57", R = {
  tabs: pn,
  tab: fn,
  active: mn
}, _n = {
  inheritAttrs: !1
}, bn = Object.assign(_n, {
  __name: "Tab",
  props: {
    disabled: {
      type: Boolean,
      required: !0
    },
    active: {
      type: Boolean,
      required: !0
    }
  },
  setup(t) {
    return (e, l) => t.disabled ? (r(), u("button", {
      key: 0,
      class: o([n(R).tab, t.active ? n(R).active : ""]),
      disabled: "",
      type: "button"
    }, [h(e.$slots, "default")], 2)) : (r(), u("a", b({
      key: 1
    }, e.$attrs, {
      class: [n(R).tab, t.active ? n(R).active : ""]
    }), [h(e.$slots, "default")], 16));
  }
});
const hn = {
  name: "ModalComponent",
  props: {
    opened: {
      type: Boolean,
      required: !0
    },
    closeModal: {
      type: Function,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    dialogAttrs: {
      type: Object,
      default: () => ({})
    },
    dialogClass: {
      type: String,
      default: ""
    },
    overlayClass: {
      type: String,
      default: ""
    },
    wrapperClass: {
      type: String,
      default: ""
    },
    contentClass: {
      type: String,
      default: ""
    },
    animationDuration: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      modalId: `modal-${Math.random().toString(36).substr(2, 9)}`,
      unsubscribe: null,
      keyHandler: null,
      lastActive: null,
      focusHandler: null,
      reallyClosed: !this.opened,
      offset: null
    };
  },
  watch: {
    opened(t, e) {
      !!t != !!e && (t ? this.handleOpened() : this.handleClosed());
    }
  },
  mounted() {
    this.opened && (this.addNoScroll(), this.addHandlers());
  },
  beforeUnmount() {
    this.unsubscribe && this.unsubscribe(), this.opened && this.removeNoScroll(), document.removeEventListener("focusin", this.focusHandler, !0), document.removeEventListener("keydown", this.keyHandler);
  },
  methods: {
    handleKeyDown({
      key: t
    }) {
      switch (t) {
        case "Escape":
          this.closeModal();
          break;
      }
    },
    handleFocus(t) {
      var p;
      const {
        documentElement: e
      } = document;
      if (!this.opened || !((p = this.$refs) != null && p.modal) || this.$refs.modal.contains(t.target) || this.$refs.modal.isEqualNode(t.target) || !e)
        return;
      const l = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', a = e.querySelectorAll(l), s = this.$refs.modal.querySelectorAll(l), c = Array.from(a).findIndex((f) => f.isEqualNode(t.target)), d = Array.from(a).findIndex((f) => f.isEqualNode(s[s.length - 1]));
      let i;
      c === -1 || c > d ? i = s[0] : i = s[s.length - 1], i && (i == null || i.focus()), e.scrollTop = this.scrollTop, e.scrollLeft = this.scrollLeft;
    },
    handleOpened() {
      const {
        activeElement: t
      } = document;
      this.addNoScroll(), this.reallyClosed = !1, this.lastActive = t;
      const {
        modal: e,
        wrapper: l
      } = this.$refs;
      this.$nextTick(() => {
        e.focus(), this.addHandlers(), this.$nextTick(() => {
          l.scrollTop = 0;
        });
      });
    },
    handleClosed() {
      document.removeEventListener("keydown", this.keyHandler), this.unsubscribe = Q(this.$refs.wrapper, () => {
        this.unsubscribe(), this.removeNoScroll(), this.unsubscribe = null, this.reallyClosed = !0, window.scrollTo(this.offset.x, this.offset.y), document.removeEventListener("focusin", this.focusHandler, !0), this.lastActive && this.lastActive.focus();
      }, this.animationDuration + 16);
    },
    addNoScroll() {
      const {
        documentElement: t,
        body: e
      } = document, l = {
        x: window.scrollX || (t || {}).scrollLeft || (e || {}).scrollLeft || 0,
        y: window.scrollY || (t || {}).scrollTop || (e || {}).scrollTop || 0
      };
      this.offset = l, t && (t.classList.add("noscroll"), t.style.top = `-${l.y}px`, t.style.left = `-${l.x}px`), e && e.classList.add("noscroll");
    },
    removeNoScroll() {
      const {
        documentElement: t,
        body: e
      } = document;
      e && e.classList.remove("noscroll"), t && (t.classList.remove("noscroll"), t.style.top = "", t.style.left = "");
    },
    addHandlers() {
      this.focusHandler = this.handleFocus.bind(this), this.keyHandler = this.handleKeyDown.bind(this), document.addEventListener("focusin", this.focusHandler, !0), document.addEventListener("keydown", this.keyHandler);
    }
  }
}, yn = ["tabIndex"], gn = ["id", "aria-modal", "aria-label"], vn = ["tabIndex"];
function kn(t, e, l, a, s, c) {
  return r(), u("div", {
    ref: "wrapper",
    class: o({
      modal: !0,
      closed: !l.opened
    })
  }, [_("div", {
    class: o(["outer-wrap", l.wrapperClass])
  }, [_("div", {
    "aria-hidden": "true",
    class: o(["overlay", l.overlayClass]),
    onClick: e[0] || (e[0] = (...d) => l.closeModal && l.closeModal(...d))
  }, null, 2), _("div", {
    tabIndex: l.opened ? "0" : void 0
  }, null, 8, yn), _("div", b({
    id: s.modalId,
    ref: "modal",
    class: ["content-wrap", l.dialogClass],
    tabIndex: "-1",
    role: "dialog",
    "aria-modal": !!l.opened,
    "aria-label": l.label
  }, l.dialogAttrs || {}), [_("div", {
    class: o(["inner-wrap", l.contentClass]),
    style: J(s.reallyClosed ? {
      display: "none"
    } : void 0)
  }, [h(t.$slots, "default")], 6)], 16, gn), _("div", {
    tabIndex: l.opened ? "0" : void 0
  }, null, 8, vn)], 2)], 2);
}
const wn = /* @__PURE__ */ fe(hn, [["render", kn]]), $n = "767px", xn = "_root_1b6g9_29", Cn = "_skipLink_1b6g9_42", Sn = "_wrapper_1b6g9_47", Mn = "_mainRight_1b6g9_56", Ln = "_pagination_1b6g9_64", qn = "_banner_1b6g9_69", In = "_top_1b6g9_72", Pn = "_bottom_1b6g9_75", On = "_buttonPrimary_1b6g9_79", Bn = "_buttonSecondary_1b6g9_131", An = "_resultsContainer_1b6g9_183", Hn = "_header_1b6g9_194", Tn = "_hr_1b6g9_200", En = "_h2_1b6g9_209", Fn = "_refinements_1b6g9_220", Nn = "_sortContainer_1b6g9_225", Rn = "_breadcrumbs_1b6g9_232", jn = "_resultsWrapper_1b6g9_236", Dn = "_modalWrapper_1b6g9_240", Wn = "_openFilters_1b6g9_244", zn = "_modalDialog_1b6g9_257", Un = "_modalDialogClosed_1b6g9_268", Kn = "_slideOut_1b6g9_1", Vn = "_modalDialogOpened_1b6g9_273", Gn = "_slideIn_1b6g9_1", Xn = "_showResults_1b6g9_280", Yn = "_modal_1b6g9_240", Jn = "_modalOverlay_1b6g9_359", Qn = "_modalContent_1b6g9_362", Zn = "_mainLeft_1b6g9_374", m = {
  maxMobileWidth: $n,
  root: xn,
  skipLink: Cn,
  wrapper: Sn,
  mainRight: Mn,
  pagination: Ln,
  banner: qn,
  top: In,
  bottom: Pn,
  buttonPrimary: On,
  buttonSecondary: Bn,
  resultsContainer: An,
  header: Hn,
  hr: Tn,
  h2: En,
  refinements: Fn,
  sortContainer: Nn,
  breadcrumbs: Rn,
  resultsWrapper: jn,
  modalWrapper: Dn,
  openFilters: Wn,
  modalDialog: zn,
  modalDialogClosed: Un,
  slideOut: Kn,
  modalDialogOpened: Vn,
  slideIn: Gn,
  showResults: Xn,
  modal: Yn,
  modalOverlay: Jn,
  modalContent: Qn,
  mainLeft: Zn
}, se = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65], el = "url('https://i.giphy.com/media/1iKIu1KU3zI52/giphy.webp')";
function tl() {
  if (typeof window > "u")
    return;
  let t = [];
  window.addEventListener("keydown", (e) => {
    const l = t.push(e.keyCode) - 1, {
      style: a = {}
    } = document.body || {};
    t[l] === se[l] ? t.length === se.length && (a.backgroundImage ? a.backgroundImage = "" : a.backgroundImage = el, t = []) : (t = [], a.backgroundImage = "");
  }, !0);
}
const ae = (t) => t && typeof t == "object", nl = ["aria-controls"], ll = ["id"], il = {
  __name: "SearchPage",
  props: {
    pagination: {
      type: Object,
      required: !0
    },
    filterMenus: {
      type: Array,
      required: !0
    },
    heading: {
      type: Object,
      required: !0
    },
    itemsPerPage: {
      type: Array,
      default: null
    },
    useCdrBreadcrumbs: {
      type: Boolean,
      default: !1
    },
    breadcrumbs: {
      type: Array,
      required: !0
    },
    appliedRefinements: {
      type: Object,
      required: !0
    },
    sorter: {
      type: Object,
      default: null
    },
    resultsId: {
      type: String,
      required: !0
    },
    tabs: {
      type: Array,
      default: null,
      validator: (t) => t.every((e) => ae(e) && ae(e.data) && typeof e.data.key == "string" && typeof e.label == "string")
    },
    filterModal: {
      type: Object,
      required: !0,
      validator: (t) => [["id", String], ["open", Function], ["close", Function], ["opened", Boolean], ["loading", Boolean], ["closeButtonText", String]].reduce((e, [l, a]) => e ? l in t && t[l] != null && Object.getPrototypeOf(t[l]) === a.prototype : !1, !0)
    }
  },
  setup(t) {
    const e = t, l = $(null), a = w(() => {
      const i = e.appliedRefinements.items.length;
      return `Filter${i ? ` (${i})` : ""}`;
    }), s = w(() => !!(e.tabs && e.tabs.length)), c = w(() => e.filterModal.opened ? m.modalDialogOpened : m.modalDialogClosed);
    function d(i) {
      i.matches || !e.filterModal.opened || e.filterModal.close();
    }
    return de(() => {
      tl(), l.value = window.matchMedia(`(max-width: ${m.maxMobileWidth})`), l.value.addListener(d);
    }), ie(() => l.value.removeListener(d)), (i, p) => (r(), x(n(Me), {
      class: o(n(m).root)
    }, {
      default: M(() => [v(Pe, {
        class: o(n(m).skipLink),
        link: e.resultsId,
        text: "search results"
      }, null, 8, ["class", "link"]), _("header", {
        class: o([n(m).header, !s.value && n(m).hr])
      }, [i.$slots.headerAlert ? (r(), u("div", {
        key: 0,
        class: o(n(m).banner)
      }, [h(i.$slots, "headerAlert")], 2)) : k("", !0), v(je, {
        class: o(n(m).breadcrumbs),
        items: e.breadcrumbs,
        "use-cdr-breadcrumbs": e.useCdrBreadcrumbs
      }, null, 8, ["class", "items", "use-cdr-breadcrumbs"]), v(Ae, b(e.heading, {
        class: n(m).heading
      }), null, 16, ["class"])], 2), s.value ? (r(), u("div", {
        key: 0,
        class: o(n(R).tabs)
      }, [(r(!0), u(q, null, O(e.tabs, (f, y) => (r(), x(bn, b({
        key: y
      }, f.data), {
        default: M(() => [P(C(f.label), 1)]),
        _: 2
      }, 1040))), 128))], 2)) : k("", !0), _("div", {
        class: o(n(m).wrapper)
      }, [v(wn, {
        id: e.filterModal.id,
        label: "Filter results",
        opened: e.filterModal.opened,
        class: o(n(m).modal),
        "dialog-class": `${n(m).modalDialog} ${c.value}`,
        "overlay-class": n(m).modalOverlay,
        "content-class": n(m).modalContent,
        "wrapper-class": n(m).modalWrapper,
        "close-modal": e.filterModal.close
      }, {
        default: M(() => [_("h2", {
          class: o([n(m).h2, n(m).filterHeading])
        }, " Filter ", 2), v(ne, b(e.appliedRefinements, {
          class: [n(S).mobileShown, n(m).refinements]
        }), null, 16, ["class"]), v(Nt, {
          items: e.filterMenus
        }, {
          default: M((f) => [h(i.$slots, "filterMenu", T(j(f)))]),
          _: 3
        }, 8, ["items"]), _("div", {
          class: o([n(m).showResults, n(S).mobileShown, c.value || n(S).hidden])
        }, [_("button", {
          type: "button",
          class: o(n(m).buttonPrimary),
          onClick: p[0] || (p[0] = (...f) => e.filterModal.close && e.filterModal.close(...f))
        }, [e.filterModal.loading ? (r(), x(jt, {
          key: 0
        })) : (r(), u(q, {
          key: 1
        }, [P(C(e.filterModal.closeButtonText), 1)], 64))], 2)], 2)]),
        _: 3
      }, 8, ["id", "opened", "class", "dialog-class", "overlay-class", "content-class", "wrapper-class", "close-modal"]), _("div", {
        class: o(n(m).mainRight)
      }, [v(ne, b(e.appliedRefinements, {
        class: [n(S).mobileHidden, n(m).refinements]
      }), null, 16, ["class"]), i.$slots.topBanner ? (r(), u("div", {
        key: 0,
        class: o([n(m).banner, n(m).top])
      }, [h(i.$slots, "topBanner")], 2)) : k("", !0), _("div", {
        class: o(n(m).sortContainer)
      }, [_("button", {
        type: "button",
        "aria-controls": e.filterModal.id,
        class: o([n(m).buttonSecondary, n(S).mobileShown, n(m).openFilters]),
        onClick: p[1] || (p[1] = (...f) => e.filterModal.open && e.filterModal.open(...f))
      }, C(a.value), 11, nl), e.sorter ? (r(), x(Xt, T(b({
        key: 0
      }, e.sorter)), null, 16)) : k("", !0), e.itemsPerPage ? (r(), u("div", {
        key: 1,
        class: o([n(m).pageCount, n(S).mobileHidden])
      }, [v(cn, {
        items: e.itemsPerPage
      }, null, 8, ["items"])], 2)) : k("", !0)], 2), i.$slots.default ? (r(), u("div", {
        key: 1,
        id: e.resultsId,
        class: o(n(m).resultsContainer)
      }, [h(i.$slots, "default")], 10, ll)) : k("", !0), v(sn, b(e.pagination, {
        class: n(m).pagination
      }), null, 16, ["class"]), i.$slots.bottomBanner ? (r(), u("div", {
        key: 2,
        class: o([n(m).banner, n(m).bottom])
      }, [h(i.$slots, "bottomBanner")], 2)) : k("", !0)], 2)], 2)]),
      _: 3
    }, 8, ["class"]));
  }
};
export {
  At as Accordion,
  ce as FilterLink,
  yt as FilterLinkList,
  Tt as FilterMenu,
  il as SearchPage
};
